<script setup lang="ts">
import type { EmployeeData } from 'types/blocks';

defineProps<{
  data: EmployeeData;
}>();
</script>

<template>
  <section
    v-if="data"
    class="container flex flex-col"
  >
    <div
      v-if="data.header || data.subtext"
      class="mb-8 md:w-2/3 lg:col-span-8 lg:mb-16"
    >
      <h2
        v-if="data.header"
        class="mb-4 font-semibold lg:mb-4"
      >
        {{ data.header }}
      </h2>
      <BaseRte
        v-if="data.subtext"
        class="lg:text-xl"
        :content="data.subtext"
      />
    </div>

    <BaseList
      v-if="data.employees.length"
      transition-name="dropdown-fade"
      class="grid grid-cols-12 gap-8"
      :aria-label="$t('Aria.Blocks.EmployeeList')"
    >
      <li
        v-for="(employee, index) in data.employees"
        :key="`${employee.name}-${employee.title}-${index}`"
        class="col-span-6 md:col-span-4 lg:col-span-2"
      >
        <PartialsEmployeeListItem
          :employee-data="employee"
          :image-portrait="data.imagePortrait"
        />
      </li>
    </BaseList>
  </section>
</template>
